import { render, staticRenderFns } from "./AttachmentDocumentType.vue?vue&type=template&id=c70b43b0&"
import script from "./AttachmentDocumentType.vue?vue&type=script&lang=js&"
export * from "./AttachmentDocumentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports